import {InjectionToken} from '@angular/core';

import {DayOfWeek, ServiceRegion} from '../common/constants';

/**
 @deprecated Do not use RegionUIConfigToken or RegionUiConfig. Either make use of the 'region' store slice or inject ClientDateServiceToken.
 */

export const RegionUIConfigToken = new InjectionToken<DayOfWeek>('RegionUIConfigToken');

export declare interface IRegionUiConfig {
  uiConfig: {
    dateFormat: string;
    alternateDateFormat?: string;
    startOfWeek: DayOfWeek;
    weekEndingDay: DayOfWeek;
  };
}

export const RegionUiConfig: { [region: string]: IRegionUiConfig } = {
  [ServiceRegion.UK]: {
    uiConfig: {
      dateFormat: 'DD/MM/YYYY',
      alternateDateFormat: 'DD/MM/YYYY',
      startOfWeek: DayOfWeek.Monday,
      weekEndingDay: DayOfWeek.Sunday
    },
  },
  [ServiceRegion.USA]: {
    uiConfig: {
      dateFormat: 'MM/DD/YY',
      startOfWeek: DayOfWeek.Sunday,
      weekEndingDay: DayOfWeek.Saturday
    }
  }
};
